// ============================================================================
// USER MANAGEMENT SERVICE
// ============================================================================

import { get, put } from '../client/axiosClient';
import { userManagementEndpoints } from '../endpoints/userManagement.endpoints';
import type { ApiResponse, ID } from '../types';
import type { UserCacheRecord, AdminResetPasswordRequest } from '../types/userManagement.types';

class UserManagementService {
  async getUsers(): Promise<ApiResponse<UserCacheRecord[]>> {
    const response = await get<ApiResponse<UserCacheRecord[]>>(userManagementEndpoints.list());
    return response.data;
  }

  async resetPassword(userId: ID, payload: AdminResetPasswordRequest): Promise<ApiResponse<void>> {
    const response = await put<ApiResponse<void>>(userManagementEndpoints.resetPassword(userId), payload);
    return response.data;
  }
}

export const userManagementService = new UserManagementService();
export default userManagementService;
